export default __webpack_public_path__ + "static/media/8_1_hl.7990b23e.png";